export default {
  ALARM: "alarm",      // 現場警報
  NOTIFY: "notify",    // クラウド設定警報
  AI: "ai",    // AI警報
  IOT: "iot",  // IoT機器警報
  SYSTEM: "cloud",  // システム警報
  SAIIK: 'saiik', // SaiIK警報
}
